import { FuseResult } from 'fuse.js';

export function getFuseResults<T>(fuseResults: FuseResult<T>[]) {
  if (!fuseResults) {
    return [];
  }
  return fuseResults.map((result) => result.item);
}
